module.exports = __webpack_public_path__ + "img/governing_board.915f480a.jpg";